import { render, staticRenderFns } from "./FrameAssemblyUpdateDialog.vue?vue&type=template&id=71a62830&scoped=true"
import script from "./FrameAssemblyUpdateDialog.vue?vue&type=script&lang=ts"
export * from "./FrameAssemblyUpdateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a62830",
  null
  
)

export default component.exports